import React from 'react';

interface LogIconProps {
    size?: number;
    color?: string;
}

export const LogIcon: React.FC<LogIconProps> = ({ size = 16, color = 'currentColor' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
        >
            {/* Paper */}
            <path
                d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                fill="none"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Fold */}
            <path
                d="M14 2V8H20"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Lines representing text */}
            <line x1="8" y1="13" x2="16" y2="13" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="8" y1="17" x2="16" y2="17" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="8" y1="9" x2="10" y2="9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
